import { useEffect } from 'react';
import { RTMTableMiniModalProps } from '../types/RTMTypes';
import moment from 'moment';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { t } from 'i18next';
import Style from '../styles/RTMTableMiniModalView.module.scss';
import { Button } from '@mui/material';

const RTMTableMiniModalView = (props: RTMTableMiniModalProps) => {
  const { showModal, handleCloseModal, selectedProduct } = props;

  useEffect(() => {
    if (showModal) {
      document.documentElement.classList.add('modal-open');
    } else {
      document.documentElement.classList.remove('modal-open');
    }

    return () => {
      document.documentElement.classList.remove('modal-open');
    };
  }, [showModal]);

  return (
    <Dialog className={Style.RTMTableMiniModalView} open={showModal} onClose={handleCloseModal} maxWidth='lg' fullWidth>
      <div className='RTMTableMiniModalView-container'>
        <DialogTitle>
          {t('Product Details')}
          <IconButton className='icon-button' aria-label='close' onClick={handleCloseModal}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <div className='product-info-container'>
            <div className='product-left'>
              <div
                className={`dotConnection ${selectedProduct?.connectionState.toLowerCase() === 'online' ? 'online' : 'offline'}`}
              ></div>
              <img src={selectedProduct?.imageUri} alt='Product' className='product-image' />
            </div>
            <div className='product-right'>
              <p>
                <strong>{t('Name')}:</strong> {selectedProduct?.name}
              </p>
              <p>
                <strong>{t('PUUID')}:</strong> {selectedProduct?.puuid}
              </p>
              <p>
                <strong>{t('Status')}:</strong> {selectedProduct?.status}
              </p>
              <p>
                <strong>{t('Last Status Date')}:</strong> {moment(selectedProduct?.lastStatusDate).format('DD/MM/YYYY HH:mm')}
              </p>
            </div>
          </div>

          <h4 className='events-title'>{t('Related Events')}</h4>
          <div className='modal-events-container'>
            {selectedProduct.alertsAndEvents.length > 0 ? (
              <table className='table table-striped'>
                <thead>
                  <tr>
                    <th>{t('Timestamp')}</th>
                    <th>{t('Name')}</th>
                    <th>{t('Description')}</th>
                    <th>{t('Type')}</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedProduct.alertsAndEvents.map((element, index) => (
                    <tr key={index}>
                      <td>{moment(element.timestamp).format('DD/MM/YYYY HH:mm')}</td>
                      <td>{element.name}</td>
                      <td>{element.description}</td>
                      <td>
                        <button
                          className={`custom-button-span-RTM ${
                            element.alarmType ? element.alarmType.toLowerCase() : element.type.toLowerCase()
                          }`}
                        >
                          {element.alarmType ? element.alarmType : element.type}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>{t('noevents')}</p>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button className='primary pull-right' onClick={handleCloseModal}>
            {t('actions.close')}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default RTMTableMiniModalView;
